
/********************************************
 * Hamburger Menu
 ********************************************/
function fnHamburgerMenu() {

    var oBody = $('body'),
        oNav = $('nav'),
        oMenu = $('#menu-header-menu-container'),
        oFullMenu = $('.full-screen-menu'),
        oMenuItem = oNav.find('.right-col > li'),
        oMenuItems = $('.menu-item'),
        oMenuLinks = $('.menu-item > a'),
        oMenuItemWithChildren = $('.menu-item-has-children'),
        oSectorsSubmenu = $('.sectors-items'),
        oHeader = $('header.primary'),
        oLogo = $('.logoLink'),
        oNavCta = $('.desktop-nav-cta');

       


    // On-click menu
    oBody.on('click', '.hamburger-menu', function () {
        console.log('BURGER CLICKEDDD')
        $(this).toggleClass('is-active');
        oFullMenu.toggleClass('is-active');
        if (oFullMenu.hasClass('is-active')) {
            setTimeout(function () {
                oBody.addClass('is-fixed');
            }, 300)
        } else {
            oBody.removeClass('is-fixed');
        }
        return false;
    });

    /*Menu Items Hover*/
    if ($(window).width() > 1024) {
        oMenuItem.mouseover(function () {
            oMenuItem.removeClass('current');
            $(this).addClass('current');
            oMenu.addClass('is-hovered');
            if ($(this).hasClass('has-sectors')) {
                oMenu.addClass('sectors');
            } else if($(this).find('a').attr('title') === 'Contact'){
                oMenu.addClass('contact');
            } else{
                oMenu.removeClass('sectors contact');
            }

        })
            .mouseout(function (e) {
                oMenu.removeClass('is-hovered');
            });
    }

    if ($(window).width() > 1024) {
        oMenuItemWithChildren.hover(function() {
            console.log('item hovered')
            oHeader.addClass("dropdown-active"); 
        }, function() {
            oHeader.removeClass("dropdown-active");
        });
    }

    if ($(window).width() > 1024) {
        oMenuItemWithChildren.hover(function() {
            oNavCta.addClass("invert-cta"); 
            oLogo.addClass('invert-svg');
            oMenuItems.addClass('invert-menu-items');
        }, function() {
            oNavCta.removeClass("invert-cta");
            oLogo.removeClass('invert-svg');
            oMenuItems.removeClass('invert-menu-items');
        });

        oMenuItems.hover(function() {
            if ($(this).closest('.menu-item').is(oMenuItems)) {
                // Add class only to the first child anchor of the top-level item
                $(this).children('a:first-child').addClass("item-hovered");
              } else {
                // Remove class from any previously hovered nested element (optional)
                $(this).children('a:first-child').removeClass("item-hovered");
              }
            }, function() {
              // Remove class on mouseleave from top-level item's first child anchor
              $(this).children('a:first-child').removeClass("item-hovered");
        });

        // oMenuItems.children('a').hover(function(event) {
        //     // Stop event bubbling to parent li
        //     event.stopPropagation();
          
        //     // Check if the hovered element is a top-level anchor (optional)
        //     if ($(this).parent().is('.menu-item')) {
        //       $(this).addClass("item-hovered");
        //     }
        //   }, function() {
        //     $(this).removeClass("item-hovered");
        //   });
    }


    let submenuAppended = false; // Flag to track if the submenu has already been appended

    function fnSectorsSubmenu() {
        if ($(window).width() > 1024) {
            // For screens wider than 1024px, move the submenu to the correct position
            oSectorsSubmenu.insertAfter('.contact-info');
            oBody.off('click', '.menu li.has-sectors');  // Remove event listener for wider screens
        } else {
            // For smaller screens, loop through each menu item
            $('.menu li.has-sectors').each(function() {
                var $menuItem = $(this);

                // Extract the index from the class name, e.g. 'menu-item-1' -> index 1
                var menuItemClass = $menuItem.attr('class');
                var match = menuItemClass.match(/menu-item(\d+)/); // Match 'menu-item-X'
                var itemIndex = match ? match[1] : null; // Extract the index (X)

                if (itemIndex) {
                    var oSectorsSubmenu = $('.sectors-items' + itemIndex); // Get the corresponding submenu by class

                    if (oSectorsSubmenu.length) {
                        // Append the submenu under the corresponding menu item
                        if (!oSectorsSubmenu.hasClass('appended')) {
                            oSectorsSubmenu.appendTo($menuItem);
                            oSectorsSubmenu.addClass('appended'); // Mark as appended to prevent re-appending
                        }
                    }

                    // Add the click event for smaller screens
                    $menuItem.on('click', function(e) {
                        e.preventDefault();

                        // Toggle the 'active' class and slide toggle submenu
                        $menuItem.toggleClass('current');
                        oSectorsSubmenu.stop(true, true).slideToggle(500);
                    });
                }
            });
        }
    }

// Initial function call
    fnSectorsSubmenu();

// Re-run on window resize
    $(window).resize(function() {
        fnSectorsSubmenu();
    });



}
